/* Greenstone Startseite: Reveal, Hero-Animation, 360°-Ansicht, Ablauf-Linie.
   Jede Funktion initialisiert sich pro Section und erneut nach Änderungen im Theme-Editor. */
(function () {
  if (window.__gsxHome) return; window.__gsxHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  function reveal(root) {
    root.querySelectorAll('.gsx-rv, .gsx-steps').forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  /* Hero: Partikel starten an der Düse im Foto.
     Die Düsenposition ist in Prozent des Originalbilds hinterlegt und wird
     über object-fit: cover / object-position auf den Bildschirm umgerechnet. */
  function hero(root) {
    var stage = root.matches && root.matches('[data-gsx-stage]') ? root : root.querySelector('[data-gsx-stage]'); if (!stage || stage.__gsx) return; stage.__gsx = true;
    var cv = stage.querySelector('canvas'), ctx = cv.getContext('2d');
    var btns = stage.querySelectorAll('[data-mode]'), pill = stage.querySelector('.gsx-switch__pill'), cap = stage.querySelector('[data-gsx-cap]');
    var imgs = { ice: stage.querySelector('[data-img="ice"]'), steam: stage.querySelector('[data-img="steam"]') };
    var d = stage.dataset, n = function (k, def) { var v = parseFloat(d[k]); return isNaN(v) ? def : v; };
    var cfg = {
      ice:   { nx: n('iceX', 35.5) / 100, ny: n('iceY', 9) / 100, ang: n('iceA', 116) * Math.PI / 180, spread: .13, speed: [.009, .014], life: [42, 70], size: [.6, 1.2], rate: 4 },
      steam: { nx: n('steamX', 46) / 100, ny: n('steamY', 41) / 100, ang: n('steamA', 148) * Math.PI / 180, spread: .5, speed: [.004, .008], life: [60, 110], size: [5, 13], rate: 4 }
    };
    var pressed = stage.querySelector('[data-mode][aria-pressed="true"]'), mode = pressed ? pressed.dataset.mode : 'ice', parts = [], running = false, W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), origin = { x: 0, y: 0, s: 1 };
    /* weicher Nebel-Sprite, einmal vorberechnet */
    var sprite = document.createElement('canvas'); sprite.width = sprite.height = 64;
    var sg = sprite.getContext('2d'), grad = sg.createRadialGradient(32, 32, 0, 32, 32, 32);
    grad.addColorStop(0, 'rgba(255,255,255,1)'); grad.addColorStop(.45, 'rgba(255,255,255,.35)'); grad.addColorStop(1, 'rgba(255,255,255,0)');
    sg.fillStyle = grad; sg.fillRect(0, 0, 64, 64);

    function place() {
      var img = imgs[mode]; if (!img || !img.naturalWidth) return;
      var iw = img.naturalWidth, ih = img.naturalHeight, s = Math.max(W / iw, H / ih), rw = iw * s, rh = ih * s;
      var pos = getComputedStyle(img).objectPosition.split(' '), px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
      if (isNaN(px)) px = .5; if (isNaN(py)) py = .5;
      origin = { x: (W - rw) * px + cfg[mode].nx * rw, y: (H - rh) * py + cfg[mode].ny * rh, s: rh };
    }
    function size() { var r = stage.getBoundingClientRect(); W = r.width; H = r.height; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); place(); }
    function rnd(a) { return a[0] + Math.random() * (a[1] - a[0]); }
    function spawn() {
      var c = cfg[mode];
      for (var i = 0; i < c.rate; i++) {
        var a = c.ang + (Math.random() - .5) * c.spread, v = rnd(c.speed) * origin.s;
        parts.push({ x: origin.x, y: origin.y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, l: 0, L: rnd(c.life), r: rnd(c.size), w: Math.random() * 6.28 });
      }
    }
    function frame() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H); spawn();
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.l++;
        var k = p.l / p.L; if (k >= 1) { parts.splice(i, 1); continue; }
        if (mode === 'ice') {
          /* Pellets als gezogene Streifen in Flugrichtung, dazu ein feiner Kältenebel */
          p.x += p.vx; p.y += p.vy; p.vy += .004;
          var a = (1 - k) * (k < .08 ? k / .08 : 1);
          ctx.globalAlpha = a * .55; ctx.strokeStyle = '#eef8ff'; ctx.lineWidth = p.r; ctx.lineCap = 'round';
          ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p.x - p.vx * 4, p.y - p.vy * 4); ctx.stroke();
          if (p.w < .6) { var fr = 6 + k * 30; ctx.globalAlpha = a * .06; ctx.drawImage(sprite, p.x - fr, p.y - fr, fr * 2, fr * 2); }
        } else {
          p.vx *= .985; p.vy = p.vy * .985 - .012; p.w += .05;
          p.x += p.vx + Math.sin(p.w) * .25; p.y += p.vy;
          var r = p.r * (1 + k * 3.2);
          ctx.globalAlpha = Math.sin(k * Math.PI) * .22;
          ctx.drawImage(sprite, p.x - r, p.y - r, r * 2, r * 2);
        }
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(frame);
    }
    function start() { if (running || reduce) return; running = true; requestAnimationFrame(frame); }
    size(); window.addEventListener('resize', size);
    Object.keys(imgs).forEach(function (k) { if (imgs[k] && !imgs[k].complete) imgs[k].addEventListener('load', place); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) { start(); arm(); } else { running = false; if (timer) { clearTimeout(timer); timer = null; } } }).observe(stage);
    }
    function placePill(b) { if (!pill || !b) return; pill.style.width = b.offsetWidth + 'px'; pill.style.transform = 'translateX(' + (b.offsetLeft - 4) + 'px)'; }
    function setMode(b) {
      if (!b || b.dataset.mode === mode) return;
      mode = b.dataset.mode; parts = [];
      btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      placePill(b);
      Object.keys(imgs).forEach(function (k) { if (imgs[k]) imgs[k].classList.toggle('is-off', k !== mode); });
      if (cap) cap.textContent = b.dataset.cap || '';
      place();
    }
    /* Automatischer Wechsel Dampf / Trockeneis, nur sichtbar und ohne reduzierte Bewegung; endet beim ersten Klick */
    var autoMs = n('auto', 0) * 1000, timer = null, userPicked = false;
    function tick() {
      timer = null;
      if (userPicked || !running) return;
      var next = Array.prototype.filter.call(btns, function (x) { return x.dataset.mode !== mode; })[0];
      setMode(next); arm();
    }
    function arm() { if (autoMs > 0 && !reduce && !userPicked && !timer) timer = setTimeout(tick, autoMs); }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { userPicked = true; if (timer) { clearTimeout(timer); timer = null; } setMode(b); });
    });
    requestAnimationFrame(function () { placePill(stage.querySelector('[aria-pressed="true"]')); });
    window.addEventListener('resize', function () { placePill(stage.querySelector('[aria-pressed="true"]')); });
  }

  /* Vergleich Dampf / Trockeneis: Schieberegler mit clip-path, einmaliger Hinweis-Schwenk */
  function compare(root) {
    var box = root.querySelector('[data-gsx-cmp]'); if (!box || box.__gsx) return; box.__gsx = true;
    var range = box.querySelector('input[type=range]'), colA = root.querySelector('[data-cmp-col="a"]'), colB = root.querySelector('[data-cmp-col="b"]');
    function set(v) { box.style.setProperty('--x', v + '%'); if (colA && colB) { colA.classList.toggle('is-dim', v < 35); colB.classList.toggle('is-dim', v > 65); } }
    range.addEventListener('input', function () { set(range.value); });
    set(range.value);
    if (reduce || !('IntersectionObserver' in window) || !box.animate) return;
    var io2 = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io2.disconnect();
      var t0 = null, keys = [50, 32, 68, 50], dur = 1800;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur), seg = Math.min(2, Math.floor(p * 3)), lp = p * 3 - seg;
        var e = lp < .5 ? 4 * lp * lp * lp : 1 - Math.pow(-2 * lp + 2, 3) / 2;
        var v = keys[seg] + (keys[seg + 1] - keys[seg]) * e;
        if (!box.__touched) { range.value = v; set(v); }
        if (p < 1 && !box.__touched) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, { threshold: .6 });
    io2.observe(box);
    ['pointerdown', 'keydown'].forEach(function (ev) { range.addEventListener(ev, function () { box.__touched = true; }); });
  }

  /* Zubehör: Reiter wechseln, Reihe per Pfeil weiterschieben */
  function accessories(root) {
    if (root.__gsxAcc) return; root.__gsxAcc = true;
    var tabs = root.querySelectorAll('[role=tab]'), panels = root.querySelectorAll('.gsx-acc__panel');
    var prev = root.querySelector('[data-acc-prev]'), next = root.querySelector('[data-acc-next]');
    function active() { for (var i = 0; i < panels.length; i++) if (!panels[i].hidden) return panels[i].querySelector('.gsx-acc__row'); return null; }
    function arrows() { var r = active(); if (!r || !prev) return; prev.disabled = r.scrollLeft < 4; next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 4; }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
        var r = active(); if (r) r.scrollLeft = 0; arrows();
      });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return;
        var n = tabs[(i + k + tabs.length) % tabs.length]; n.focus(); n.click();
      });
    });
    function page(dir) { var r = active(); if (r) r.scrollBy({ left: dir * r.clientWidth * .9, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) { prev.addEventListener('click', function () { page(-1); }); next.addEventListener('click', function () { page(1); }); }
    panels.forEach(function (p) { var r = p.querySelector('.gsx-acc__row'); if (r) r.addEventListener('scroll', arrows, { passive: true }); });
    arrows();
  }

  /* 360°-Ansicht: Scroll-Fortschritt (Desktop) und Ziehen (alle Geräte) */
  function spin(root) {
    var track = root.querySelector('[data-gsx-spin]'); if (!track || track.__gsx) return; track.__gsx = true;
    var view = track.querySelector('.gsx-spin__view'), imgs = view.querySelectorAll('img'), steps = track.querySelectorAll('.gsx-spin__steps li'), bar = track.querySelector('.gsx-spin__bar');
    if (!imgs.length) return;
    var cur = -1, on = false, drag = null, sx = 0, si = 0;
    function show(i) { if (i === cur) return; cur = i; imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); }); steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); }); }
    function tick() {
      if (!on) return;
      if (drag === null && window.innerWidth > 900) {
        var r = track.getBoundingClientRect(), total = r.height - window.innerHeight, p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        if (bar) bar.style.transform = 'scaleX(' + p + ')';
        show(Math.min(imgs.length - 1, Math.floor(p * imgs.length)));
      }
      requestAnimationFrame(tick);
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { on = es[0].isIntersecting; if (on) requestAnimationFrame(tick); }).observe(track);
    show(0); view.classList.add('is-ready');
    steps.forEach(function (s, j) { s.addEventListener('click', function () { show(j); }); });
    view.addEventListener('pointerdown', function (e) { sx = e.clientX; si = Math.max(cur, 0); drag = si; view.setPointerCapture(e.pointerId); view.style.cursor = 'grabbing'; });
    view.addEventListener('pointermove', function (e) { if (drag === null) return; var n = imgs.length, d = Math.round((e.clientX - sx) / 60); drag = ((si + d) % n + n) % n; show(drag); });
    ['pointerup', 'pointercancel'].forEach(function (ev) { view.addEventListener(ev, function () { drag = null; view.style.cursor = ''; }); });
  }

  function init(root) { root = root || document; reveal(root); root.querySelectorAll('.gsx-hero').forEach(hero); root.querySelectorAll('.gsx-spin').forEach(spin); root.querySelectorAll('.gsx-cmp-sec').forEach(compare); root.querySelectorAll('.gsx-acc').forEach(accessories); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
